export enum NotificationOptions {
  NoAction = 'no action',
  Action = 'action',
  ViewMore = 'view more',
}
